
    import {Component, Prop, Vue} from 'vue-property-decorator';

    @Component
    export default class PriceCard extends Vue
    {
        @Prop({required: true})
        protected title!: string;
    }
